import React from "react";
import { useProfile } from "../../../../context/ProfileContext";
import styles from "./profileComp.module.scss";
import Icon from "../../../../components/Icon";
import Button from "../../../../components/Button";

const Certifications = () => {
  const {
    profileInfo,
    handleFocus,
    current,
    handleDiscard,
    handleDiscardData,
    updatedField,
    setProfileInfo,
    handleSubmit,
  } = useProfile();

  const handleCertification = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const UpdatedArray = [...(profileInfo?.otherCertifications ?? [])];

    UpdatedArray[Number(name)] = value;
    setProfileInfo((prev: any) => ({
      ...prev,
      otherCertifications: UpdatedArray,
    }));
  };

  const addNewCertificate = () => {
    setProfileInfo((prev: any) => ({
      ...prev,
      otherCertifications: [...prev.otherCertifications, "New Certification"],
    }));
  };
  return (
    <div
      className={`${
        current?.section === "certificate"
          ? `${styles.editing}`
          : current?.section === ""
          ? `${styles.neutral} `
          : null
      } ${styles.InfoContainer}`}
    >
      <div className={styles.Header}>
        <h3>Certifications</h3>

        {current?.section === "certificate" && (
          <div className={styles.headerStatus}>
            <Icon name="edit" width={15} height={15} className={styles.edits} />
            <p>editing</p>
          </div>
        )}
      </div>
      {profileInfo?.otherCertifications && profileInfo.otherCertifications.length > 0 ? (
        profileInfo?.otherCertifications?.map((certificate: string, index: number) => (
          <div key={index}>
            <label htmlFor="lastName" className={styles.labels}>
              Cerfication
            </label>
            <div className={styles.contBoxes}>
              <div
                className={`${styles.inputContainer}  ${
                  updatedField?.fieldName === "certificate" ? styles.editingField : null
                }`}
              >
                <input
                  id={`certification${index}`}
                  type="text"
                  className={styles.basicInputs}
                  onChange={handleCertification}
                  name={String(index)}
                  value={certificate}
                  placeholder="certification"
                  onFocus={() => {
                    handleFocus(String(index), "certificate");
                    handleDiscardData("otherCertifications");
                  }}
                />
                <div>
                  <Icon name="edit" width={20} height={20} className={styles.edits} />
                </div>

                {(current?.fieldName === String(index) ||
                  updatedField?.fieldName === String(index)) && (
                  <div className={styles.saves}>
                    <button
                      className={styles.save}
                      onClick={(e: any) => handleSubmit(e, "otherCertifications")}
                    >
                      Save
                    </button>
                    <button
                      className={styles.discard}
                      onClick={() => handleDiscard("otherCertifications")}
                    >
                      Discard
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className={styles.noData}>
          <span style={{ fontSize: "16px" }}>You've not added a certification.</span>
          <span style={{ fontSize: "11px" }}>Click the plus button at the top right</span>
          <Button variant="primary" className={styles.addsCert} onClick={addNewCertificate}>
            + Add Certification
          </Button>
        </div>
      )}
    </div>
  );
};

export default Certifications;
